module.exports = __webpack_public_path__ + "media/images/icons/flags/RS-97b412167dff493f153ce809e32a9fea.svg";